import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { primary10, PRIMARY_COLOR } from "../constants/colors";
import { TMenuItem } from "../@types/common";
import { useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { AnimateChildren } from "../components/elements/Elements";

export const MenuItem = ({
  data: { label, icon: Icon, to, onClick: itemClick, children, visible = true },
  selected,
  onClick: menuDefaultClick,
}: {
  data: TMenuItem;
  selected?: boolean;
  onClick?: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => children && setOpen(!open);

  if (!visible) return null;

  return (
    <>
      {/* MENU ITEM */}
      <Link
        to={to}
        className="textDark"
        onClick={() => {
          toggleOpen();
          if (itemClick) itemClick();
          if (menuDefaultClick) menuDefaultClick();
        }}
      >
        <ItemWrapper
          className="flexNullCenter gap15 r10 animate pointer"
          selected={selected}
        >
          {Icon && <Icon fontSize={17} />}
          <div className="flexGrow">
            <div className="font13 capitalize">{label}</div>
          </div>

          {children && (
            <KeyboardArrowDown
              className="grey"
              fontSize="small"
              style={{
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease-in-out",
              }}
            />
          )}
        </ItemWrapper>
      </Link>

      {/* SUB MENU */}
      {open && (
        <div
          className="lightBg r10 flexColumn gap5 hidden"
          style={{
            marginTop: 5,
            // height: open ? "auto" : 0,
            // overflow: "hidden",
            // transition: "height 0.3s ease-in-out",
          }}
        >
          <RenderItems items={children} />
        </div>
      )}
    </>
  );
};

const ItemWrapper = styled.div<{ selected?: boolean }>`
  padding: 10px;

  ${({ selected }) =>
    selected &&
    `
     color: white;
      font-weight: 500;
      background-color: ${PRIMARY_COLOR};
    `}

  &:hover {
    color: ${PRIMARY_COLOR};
    font-weight: 500;
    background-color: ${primary10};
  }
`;

const RenderItems = ({
  items,
  onItemClick,
}: {
  items: TMenuItem[] | undefined;
  onItemClick?: any;
}) => {
  const { pathname } = useLocation();
  return (
    <AnimateChildren>
      {items?.map((v, i) => {
        const selected = pathname === `/${v?.to}`?.replaceAll("//", "/");
        return (
          <MenuItem
            key={i}
            data={v}
            selected={selected}
            onClick={onItemClick}
          />
        );
      })}
    </AnimateChildren>
  );
};

export const RenderNavMenu = ({
  onItemClick,
  menu,
}: {
  onItemClick?: () => void;
  menu: { title?: any; items: TMenuItem[] }[];
}) => {
  return (
    <>
      {menu?.map(({ title, items }, i) => (
        <div key={i}>
          {title && <div className="capitalize grey font12 p10">{title}</div>}
          <RenderItems items={items} onItemClick={onItemClick} />
        </div>
      ))}
    </>
  );
};
